import { render, staticRenderFns } from "./MoveBtnItem.vue?vue&type=template&id=2a92fcce&scoped=true&"
import script from "./MoveBtnItem.vue?vue&type=script&lang=js&"
export * from "./MoveBtnItem.vue?vue&type=script&lang=js&"
import style0 from "./MoveBtnItem.vue?vue&type=style&index=0&id=2a92fcce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a92fcce",
  null
  
)

export default component.exports